import ImageCta from './imageCta';

export default ImageCta;
